import { HIUser} from './HIUser';
import { PenBooking } from '../shared/pets/PenBooking';
export class Booking {
  sid: number;
  customer: HIUser;
  customerName: string;
  customerSid: number;
  kennelSid: number;
  dateIn: string;
  dateOut: string;
  penBookings: PenBooking[] = [];
  // pets: Pet[];
  totalNights: number;
  totalCost: number;
  deleted = false;
  reservationNumber: number;
}
